import _ from "lodash"
import moment from "moment"
import Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"

import mapperPassengerAdvices from "./mapperPassengerAdvices"

export default function(inputPassengers, inputTravelInfo, handBagsAllowedForInfants) {
  const passengers = []
  _.forEach(inputPassengers, passengerObj => {
    // Map deprecated insurance names `skysilver` and `skygold`
    const passengerInsurance = passengerObj.insurance_type || "none"

    const firstAndMiddleName = passengerObj.firstname.split("|")

    const passenger = new Passenger({
      id: passengerObj.id,
      category: passengerObj.category,
      title: passengerObj.title.toLowerCase(),
      firstname: firstAndMiddleName[0],
      middlename: firstAndMiddleName[1] || "",
      lastname: passengerObj.lastname,
      birth: moment(passengerObj.birthday, "YYYY-MM-DD"),
      nationality: passengerObj.nationality.toLowerCase(),
      insurance: passengerInsurance,
      insurancePrice: Number(passengerObj.insurance_price || 0),

      bags: passengerObj.bags, // old bookings null value

      priorityBoarding: passengerObj.priority_boarding || {},
    })

    passenger.extraHandBags = passenger.hasBagsAllowed(handBagsAllowedForInfants) ? 1 : 0

    // Special frontier case for now {1: 1 // personal item, 2: x // paid hang bag}
    if (passengerObj.hand_bags && passengerObj.hand_bags["2"]) {
      passenger.handBags = passengerObj.hand_bags["2"]
    }

    if (passengerObj.travel_document) {
      passenger.document = {
        code: passengerObj.travel_document.cardno,
        expiration: passengerObj.travel_document.expiration
          ? moment.utc(passengerObj.travel_document.expiration * 1000).format("YYYY-MM-DD")
          : undefined,
      }
    }

    if (typeof inputTravelInfo === "object") {
      if (inputTravelInfo[passengerObj.id]) {
        passenger.advices = mapperPassengerAdvices(inputTravelInfo[passengerObj.id])
      }
    }

    passengers.push(passenger)
  })

  return passengers
}
